import runtime from './runtime'

export function getDeviceLevel() {
  return runtime.get('deviceLevel') || 'NOT_READY'
}
